import { TypeAttribute, TypeAttributeSource, TypeMetricKey } from '@trace/types';
import React, { createContext, FunctionComponent, useCallback, useContext } from 'react';
import { UseQueryResult } from 'react-query';

import { URLStateContext } from '../URLState/URLState';
import useAttributes, { HookResult } from './useAttributes';

interface Props {
  source: TypeAttributeSource;
}

type AttributesContextType = HookResult & {
  getAttributeValuesForMetric: (metric: TypeMetricKey, groupBy?: TypeAttribute) => string[];
};

const _: string[] = [];

export const AttributesContext = createContext<AttributesContextType>({
  attributes: [],
  attributesValues: {},
  isEmpty: false,
  isError: false,
  isFetched: false,
  isFetching: false,
  getAttributeValuesForMetric: () => [],
  refetch: () => Promise.resolve({} as UseQueryResult<unknown, unknown>),
});

const Attributes: FunctionComponent<Props> = ({ source, ...rest }) => {
  const attributes = useAttributes(source);
  const { attributeGroups } = useContext(URLStateContext);

  const getAttributeValuesForMetric = useCallback(
    (metric: TypeMetricKey, groupBy?: TypeAttribute) => {
      const attribute = groupBy || attributeGroups[metric];
      const values = attributes.attributesValues[attribute];
      return values || _;
    },
    [attributeGroups, attributes.attributesValues],
  );

  return (
    <AttributesContext.Provider {...rest} value={{ ...attributes, getAttributeValuesForMetric }} />
  );
};

export default Attributes;
